import { useIntl } from 'react-intl';
import { useCallback, useState } from 'react';
import { useToggleReleaseResourcesDialog } from '~/modules/resourcing/common/hooks';
import { useDialogState } from '~/modules/common/hooks';

export const useQuickAllocationProjectRowActions = ({ resourceRequestIds }) => {
  const intl = useIntl();

  const [selectedResourceRequestId, setSelectedResourceRequestId] = useState(
    null
  );

  const {
    showReleaseResourcesDialog,
    openReleaseResourcesDialog,
    closeReleaseResourcesDialog
  } = useToggleReleaseResourcesDialog();

  const onDrawerClose = useCallback(() => {
    setSelectedResourceRequestId(null);
  }, []);

  const onDrawerOpen = useCallback(({ resourceRequestId }) => {
    setSelectedResourceRequestId(resourceRequestId);
  }, []);

  const {
    open: showViewMultipleResourceRequestsDialog,
    openDialog: onViewMultipleResourceRequestsDialogOpen,
    closeDialog: onViewMultipleResourceRequestsDialogClose
  } = useDialogState(false);

  const releaseResourcesAction = {
    label: intl.formatMessage({
      id: 'resourceRequestActions.releaseResources'
    }),
    onClick: openReleaseResourcesDialog
  };

  const viewResourceRequestClickHandler = useCallback(() => {
    if (resourceRequestIds?.length === 1) {
      setSelectedResourceRequestId(resourceRequestIds[0]);
    } else {
      onViewMultipleResourceRequestsDialogOpen();
    }
  }, [onViewMultipleResourceRequestsDialogOpen, resourceRequestIds]);

  const viewResourceRequestAction = {
    label: intl.formatMessage({
      id: 'resourceRequestActions.viewResourceRequest'
    }),
    onClick: viewResourceRequestClickHandler
  };

  const actions = [
    releaseResourcesAction,
    ...(resourceRequestIds?.length ? [viewResourceRequestAction] : [])
  ];

  return {
    actions,
    showReleaseResourcesDialog,
    closeReleaseResourcesDialog,
    showViewMultipleResourceRequestsDialog,
    onViewMultipleResourceRequestsDialogClose,
    selectedResourceRequestId,
    onDrawerClose,
    onDrawerOpen,
    isDrawerOpen: Boolean(selectedResourceRequestId)
  };
};

export default useQuickAllocationProjectRowActions;
